import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroupText from 'react-bootstrap/esm/InputGroupText';

const PayBill = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [invoices, setInvoices] = useState([]);

    const handleLogin = (e) => {
        e.preventDefault();
        // Mock login logic
        if (email === 'customer@example.com' && password === 'password123') {
            setIsLoggedIn(true);
            // Mock invoices data
            setInvoices([
                { id: 1, amount: 100, dueDate: '2023-12-01' },
                { id: 2, amount: 200, dueDate: '2024-01-15' },
            ]);
        } else {
            alert('Invalid credentials');
        }
    };

    const handlePayment = (invoiceId) => {
        alert(`Payment for invoice ${invoiceId} processed.`);
        // Add payment processing logic here
    };

    return (
        <div>
            {!isLoggedIn ? (
                <Form onSubmit={handleLogin}>
                    <h2>Login to View Invoices</h2>
                    <InputGroup>
                        <InputGroup.Text>Email:</InputGroup.Text>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </InputGroup>
                    <InputGroup>
                        <InputGroup.Text>Password:</InputGroup.Text>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </InputGroup>
                    <button type="submit">Login</button>
                </Form>
            ) : (
                <div>
                    <h2>Your Invoices</h2>
                    {invoices.length > 0 ? (
                        <ul>
                            {invoices.map((invoice) => (
                                <li key={invoice.id}>
                                    Invoice #{invoice.id} - Amount: ${invoice.amount} - Due Date: {invoice.dueDate}
                                    <button onClick={() => handlePayment(invoice.id)}>Pay Now</button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No invoices available.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default PayBill;